module.exports = __webpack_public_path__ + "fonts/406061ee16296507cd6e8ccc8d870d88.ttf";